import { connect } from 'react-redux';
import { getFormValues , reduxForm} from 'redux-form';
import React, {Component} from 'react';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import DataSection from '../../comps/DataSection/DataSection';
import formFields from '../config/formFields';
import Heading from '@react/react-spectrum/Heading/js/Heading';
import { Translate } from 'react-redux-i18n';


class RegistrationCriteria extends Component{ 
    constructor()
    {
        super();
        window.scrollTo(0,0);
        this.state = {
            sectionValidation : {}
        }
    }

    updateValidation = (name,value) => {
        let sectionValidation = this.state.sectionValidation;
        sectionValidation[name] = value;
        this.setState({sectionValidation:sectionValidation});
    }

    render(){
        this.props.onValidateChange(Object.values(this.state.sectionValidation).every(Boolean));
        const formName = 'registration';
        return <div>
            <Grid>
                <GridRow >
                    <GridColumn size={[12,8,6,6]} offsetSize={[0,2,3,3]}>
                    <Heading className = "textBold" variant="pageTitle"><Translate value="registration.Welcome" /></Heading>
                    <p><Translate value="registration.OnbrdCriteriaBody" /></p>
                    <p><Translate value="registration.OnbrdCriteriaBody1" dangerousHTML/></p>
                    <Translate value="registration.OnbrdCriteriaHeader" /><span> :</span>
                    <GridRow className="textBox">
                        <GridColumn>
                        <ul>
                            <li><Translate value="registration.reg_ctr_text1" dangerousHTML/></li>
                            <li><Translate value="registration.reg_ctr_text2" dangerousHTML/></li>
                        </ul>
                        </GridColumn>
                    </GridRow>
                    <GridRow>
                        <GridColumn>
                        <DataSection formStates={this.props.formStates} form={formName} field={formFields.section2} sectionName="section2" updateValidation={this.updateValidation}/>
                        <ul>
                            <li><Translate value="registration.OnbrdCriteriaAuthorized" /></li>
                            <li><Translate value="registration.OnbrdCriteriaAuthorized1" /></li>
                        </ul>
                        </GridColumn>
                    </GridRow>
                    </GridColumn>
                </GridRow>
            </Grid>
            </div>
    }
}
RegistrationCriteria = reduxForm({
    form:'registration',
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })(RegistrationCriteria);


  function mapStateToProps(state) {
    return {
            formStates: getFormValues('registration')(state) // here 'form' is the name you have given your redux form  
        }
    }
    
    export default connect(mapStateToProps)(RegistrationCriteria);